import type { SortOptions } from '@lib/util/sort-products';
import ProductToolbar from '@modules/store/components/product-toolbar';

export function ProductGridEmptyState() {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      <p className="text-lg font-medium text-fg-neutral-strong mb-2">
        No products found
      </p>
      <p className="text-sm text-fg-neutral-soft">
        Try adjusting your filters or search criteria.
      </p>
    </div>
  );
}

export function EmptyStateWithToolbar({
  sort,
  minPrice,
  maxPrice,
}: {
  sort: SortOptions;
  minPrice?: number;
  maxPrice?: number;
}) {
  return (
    <>
      <ProductToolbar
        sortBy={sort}
        productCount={0}
        minPrice={minPrice}
        maxPrice={maxPrice}
      />
      <ProductGridEmptyState />
    </>
  );
}
